module.exports = __webpack_public_path__ + "img/logo_2.380eb081.svg";